import React from 'react';
import { NavLink } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-navy-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-gray-300">
              HTS Electrotechniek is een erkend elektrotechnisch installatiebedrijf,
              opgericht in april 2000 door Halit Suiçmez, met ervaring in de sector sinds 1987.
            </p>
            <div className="flex mt-4 space-x-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 hover:-translate-y-0.5"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2 text-white">
              Contact Informatie
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 text-orange-500" />
                <span className="text-gray-300">Installatieweg 5-1, 8263 BS Kampen</span>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="mr-2 text-orange-500" />
                <a
                  href="tel:0383336549"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  038-3336549
                </a>
              </li>
              <li className="flex items-center">
                <Mail size={18} className="mr-2 text-orange-500" />
                <a
                  href="mailto:info@htselectrotechniek.nl"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  info@htselectrotechniek.nl
                </a>
              </li>
              <li className="flex items-start">
                <Clock size={18} className="mr-2 mt-1 text-orange-500" />
                <span className="text-gray-300">24 uur per dag bereikbaar voor ondersteuning</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2 text-white">
              Diensten
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Lichtinstallaties
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Laadpalen
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Krachtinstallaties
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Zwakstroominstallaties
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Storingen oplossen
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Verlichting verkoop
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Installatiemateriaal
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Keuringen NEN 1010/3140
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 border-b border-gray-700 pb-2 text-white">
              Snelle Links
            </h3>
            <ul className="space-y-2">
              <li>
                <NavLink to="/" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  Over Ons
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  Diensten
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/projects"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  Projecten
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className="text-gray-300 hover:text-orange-500 transition-colors"
                >
                  Contact
                </NavLink>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors">
                  Privacy Beleid
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-sm text-gray-300 text-center">
          <p>
            &copy; {new Date().getFullYear()} HTS Electrotechniek - KvK-nummer: 05063491 - Alle rechten voorbehouden
          </p>
          <p className="mt-2">
            Website ontworpen en ontwikkeld door{' '}
            <a
              href="https://joy-ict.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-orange-500 hover:text-orange-400 transition-colors"
            >
              JOY-ICT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;